import ContentLoader from '@components/renderLoader';
import Loading from '@components/loading/index';
import useLazy from '@src/static/hooks/useLazyComponent';

// 在android中，因为打开多个webview，useEffect不执行，使用useLayoutEffect替换即可
// 因为suspends React.lazy导致的useEffect不执行
// 初步判断是useEffect事件冲突
// 所以切换到自定义lazy组件
const LoadableComponent = (loader: any, { title = '纸条小卖部', type = 'loding', hasNight = 1 }: any) => {
  let layout: any = {
    loader: ContentLoader,
    loding: Loading
  };

  return useLazy({
    loader,
    loading() {
      return layout[type];
    },
    title: title,
    hasNight
  });
};

const webConfig: any = [
  {
    path: '/web/help',
    component: LoadableComponent(() => import('../pages/web/help'), {
      title: '使用帮助',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/wnj_exchange',
    component: LoadableComponent(() => import('../pages/web/wnj_exchange'), {
      title: '万能胶兑换',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/longPaper',
    component: LoadableComponent(() => import('../pages/web/longPaper'), {
      title: '纸条作文',
      type: 'loding'
    })
  },
  {
    path: '/web/rules',
    component: LoadableComponent(() => import('../pages/web/rules'), {
      title: '管理细则',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/real',
    component: LoadableComponent(() => import('../pages/web/real'), {
      title: '实名认证',
      type: 'loding',
      hasNight: 0
    })
  },
  //   {
  //     path: '/web/contribute/list',
  //     component: LoadableComponent(() => import('../pages/web/contribute/list'), {
  //       title: '投稿首页',
  //       type: 'loding'
  //     })
  //   },
  //   {
  //     path: '/web/contribute/subject',
  //     component: LoadableComponent(() => import('../pages/web/contribute/subject'), {
  //       title: '投稿',
  //       type: 'loding'
  //     })
  //   },
  //   {
  //     path: '/web/contribute/search',
  //     component: LoadableComponent(() => import('../pages/web/contribute/search'), {
  //       title: '搜索默认页',
  //       type: 'loding'
  //     })
  //   },
  //   {
  //     path: '/web/contribute/freedom',
  //     component: LoadableComponent(() => import('../pages/web/contribute/freedomTheme'), {
  //       title: '自由主题',
  //       type: 'loding'
  //     })
  //   },
  {
    path: '/web/tag',
    component: LoadableComponent(() => import('../pages/web/tag'), {
      title: '推荐兴趣标签',
      type: 'loding'
    })
  },
  {
    path: '/web/sdkList',
    component: LoadableComponent(() => import('../pages/web/sdkList'), {
      title: '第三方SDK列表',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/sdk-list-harmony',
    component: LoadableComponent(() => import('../pages/web/sdk-list-harmony'), {
      title: '第三方SDK列表',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/information',
    component: LoadableComponent(() => import('../pages/web/information'), {
      title: '个人信息搜集清单',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/course/details',
    component: LoadableComponent(() => import('../pages/web/courseDetails'), {
      title: '课程详情',
      type: 'loding'
    })
  },
  {
    path: '/web/workDetails',
    component: LoadableComponent(() => import('../pages/web/work'), {
      title: '作业提交',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/workList',
    component: LoadableComponent(() => import('../pages/web/workList'), {
      title: '作业列表',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/workPush',
    component: LoadableComponent(() => import('../pages/web/workPush'), {
      title: '作业详情',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/workRecord',
    component: LoadableComponent(() => import('../pages/web/workRecord'), {
      title: '提交记录',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/recordDetails',
    component: LoadableComponent(() => import('../pages/web/workRecordDetails'), {
      title: '提交记录详情',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/plan/list',
    component: LoadableComponent(() => import('../pages/web/plan'), {
      title: '计划全景图',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/scholarship',
    component: LoadableComponent(() => import('../pages/web/scholarship'), {
      title: '奖学金资格',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/pay/guide',
    component: LoadableComponent(() => import('../pages/web/payGuide'), {
      title: '如何绑定支付方式',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/payHelp',
    component: LoadableComponent(() => import('../pages/web/payHelp'), {
      title: '常见支付问题',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/solicitationAgreement',
    component: LoadableComponent(() => import('../pages/web/solicitationAgreement'), {
      title: '纸条App征稿协议',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/monthlyPaper',
    component: LoadableComponent(() => import('../pages/web/monthlyPaper'), {
      title: '月刊纸条',
      type: 'loding'
    })
  },
  {
    path: '/web/memberHelp',
    component: LoadableComponent(() => import('../pages/web/memberHelp'), {
      title: '会员常见问题',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/memberAgreement',
    component: LoadableComponent(() => import('../pages/web/memberAgreement'), {
      title: '纸条会员用户协议',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/memberPower',
    component: LoadableComponent(() => import('../pages/web/memberPower'), {
      title: '会员权益',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/memberPowerDetail',
    component: LoadableComponent(() => import('../pages/web/memberPowerDetail'), {
      title: '纸条会员权益',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/collectionDetails',
    component: LoadableComponent(() => import('../pages/web/collectionDetails'), {
      title: '合集简介',
      type: 'loding'
    })
  },
  {
    path: '/web/member/change',
    component: LoadableComponent(() => import('../pages/web/memberChange'), {
      title: '兑换权益',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/course/exchange',
    component: LoadableComponent(() => import('../pages/web/courseExchange'), {
      title: '课程兑换',
      type: 'loding',
      hasNight: 1
    })
  },
  {
    path: '/web/activity',
    component: LoadableComponent(() => import('../pages/web/activitiy'), {
      title: '推广活动',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/invitation',
    component: LoadableComponent(() => import('../pages/web/invitation'), {
      title: '纸条宠粉',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/invitation-v2',
    component: LoadableComponent(() => import('../pages/web/invitation-v2'), {
      title: '-',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/invitation-v2/walkthrough',
    component: LoadableComponent(() => import('../pages/web/invitation-v2/walkthrough'), {
      title: '活动攻略',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/invitation-v2/collection',
    component: LoadableComponent(() => import('../pages/web/invitation-v2/collection'), {
      title: '',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/invitation-rules',
    component: LoadableComponent(() => import('../pages/web/invitation-rules'), {
      title: '活动规则',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/my-prizes',
    component: LoadableComponent(() => import('../pages/web/my-prizes'), {
      title: '我的奖品',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/examination',
    component: LoadableComponent(() => import('../pages/web/examination'), {
      title: '',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/answer-sheet',
    component: LoadableComponent(() => import('../pages/web/answer-sheet'), {
      title: '我的答卷',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/license',
    component: LoadableComponent(() => import('../pages/web/license'), {
      title: '证照信息',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/live',
    component: LoadableComponent(() => import('../pages/web/course-live'), {
      title: '',
      type: 'loding',
      hasNight: 0
    })
  },
  {
    path: '/web/monthly-intro',
    component: LoadableComponent(() => import('../pages/web/monthly-intro'), {
      title: '',
      type: 'loding'
    })
  }
];
const shareConfig: any = [
  {
    path: '/share/newprotocol.html',
    component: LoadableComponent(() => import('../pages/share/newprotocol'), {
      title: '纸条用户使用协议',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/service.html',
    component: LoadableComponent(() => import('../pages/share/service'), {
      title: '纸条服务条款',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/privacy.html',
    component: LoadableComponent(() => import('../pages/share/privacy'), {
      title: '隐私协议',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/minorAgreement.html',
    component: LoadableComponent(() => import('../pages/share/minorAgreement'), {
      title: '未成年人协议',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/toDownload.html',
    component: LoadableComponent(() => import('../pages/share/toDownload'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/download.html',
    component: LoadableComponent(() => import('../pages/share/download'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/short.html',
    component: LoadableComponent(() => import('../pages/share/short'), {
      title: '纸条作文',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/long.html',
    component: LoadableComponent(() => import('../pages/share/long'), {
      title: '纸条作文',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/section.html',
    component: LoadableComponent(() => import('../pages/share/section'), {
      title: '纸条作文',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/longNotice.html', // @deprecated
    component: LoadableComponent(() => import('../pages/share/longNotice'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/noticePage.html', // @deprecated
    component: LoadableComponent(() => import('../pages/share/noticePage'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/404.html',
    component: LoadableComponent(() => import('../pages/share/404'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/accountCancellation.html',
    component: LoadableComponent(() => import('../pages/share/accountCancellation'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/outerQuery.html',
    component: LoadableComponent(() => import('../pages/share/outerQuery'), {
      title: '推广积分查询',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/download-guide.html',
    component: LoadableComponent(() => import('../pages/share/download-guide'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/invitation-guide.html',
    component: LoadableComponent(() => import('../pages/share/invitation-guide'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/invitation-guide-v2.html',
    component: LoadableComponent(() => import('../pages/share/invitation-guide-v2'), {
      title: '作文纸条',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/coin-agreements.html',
    component: LoadableComponent(() => import('../pages/share/coin-agreements'), {
      title: '纸条App学币服务规则',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/assistance.html',
    component: LoadableComponent(() => import('../pages/share/assistance'), {
      title: '',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/assistance-v2.html',
    component: LoadableComponent(() => import('../pages/share/assistance'), {
      title: '',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/assistance-rules.html',
    component: LoadableComponent(() => import('../pages/share/assistance/rules'), {
      title: '活动规则',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/login.html',
    component: LoadableComponent(() => import('../pages/share/login'), {
      title: '',
      type: 'loader',
      hasNight: 0
    })
  },
  {
    path: '/share/dispatch.html',
    component: LoadableComponent(() => import('../pages/share/dispatch'), {
      title: '',
      type: 'loader',
      hasNight: 0
    })
  }
];
const config = webConfig.concat(shareConfig);

export default config;
